// Compatibility for older servers that do not return crop capabilities.
const LEGACY_HOLOS_SUPPORTED_CROPS = [
  "CANOLA",
  "CORN",
  "SOYBEANS",
  "SPRING_WHEAT",
];

export function isHolosCropSupported(crop, supportedCrops) {
  const allowed = Array.isArray(supportedCrops)
    ? supportedCrops
    : LEGACY_HOLOS_SUPPORTED_CROPS;
  return allowed.includes(String(crop || "").trim().toUpperCase());
}

export const HOLOS_UNSUPPORTED_CROP_MESSAGE =
  "The selected calculation service does not support this crop. You can still save the crop year.";
